import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'https://stock-api-production-913a.up.railway.app';
const getToken = () => sessionStorage.getItem('wintime_admin_token') || '';

export default function Messages() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all'); // all / unread / read

  const load = () => {
    setLoading(true);
    fetch(`${API_URL}/api/admin/messages?pw=${encodeURIComponent(getToken())}`)
      .then(r => r.json())
      .then(d => { setMessages(Array.isArray(d) ? d : []); setLoading(false); })
      .catch(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const markRead = (id) => {
    fetch(`${API_URL}/api/admin/messages/${id}/read?pw=${encodeURIComponent(getToken())}`, { method: 'POST' })
      .then(() => setMessages(prev => prev.map(m => m.id === id ? {...m, is_read: true} : m)));
  };

  const del = (id) => {
    if (!window.confirm('確定刪除這則留言？')) return;
    fetch(`${API_URL}/api/admin/messages/${id}?pw=${encodeURIComponent(getToken())}`, { method: 'DELETE' })
      .then(() => setMessages(prev => prev.filter(m => m.id !== id)));
  };

  const filtered = messages.filter(m => {
    if (filter === 'unread') return !m.is_read;
    if (filter === 'read') return m.is_read;
    return true;
  });

  const unreadCount = messages.filter(m => !m.is_read).length;

  const fmtDate = (s) => {
    if (!s) return '-';
    const d = new Date(s);
    return `${d.getFullYear()}/${String(d.getMonth()+1).padStart(2,'0')}/${String(d.getDate()).padStart(2,'0')} ${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
  };

  return (
    <div style={{ padding: 16, maxWidth: 900 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, color: '#90c0dc', margin: 0 }}>✉ 留言管理</h2>
        {unreadCount > 0 && (
          <span style={{ background: '#e05c5c', color: '#fff', borderRadius: 12, padding: '2px 10px', fontSize: 12, fontWeight: 700 }}>
            {unreadCount} 則未讀
          </span>
        )}
        <button onClick={load} style={{ marginLeft: 'auto', padding: '6px 14px', borderRadius: 6, border: '1px solid #2a4060', background: 'transparent', color: '#7ab0cc', cursor: 'pointer', fontSize: 12 }}>
          🔄 重新整理
        </button>
      </div>

      {/* 篩選 */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {[['all','全部'], ['unread','未讀'], ['read','已讀']].map(([v, l]) => (
          <button key={v} onClick={() => setFilter(v)}
            style={{ padding: '6px 16px', borderRadius: 6, border: 'none', cursor: 'pointer', fontSize: 13,
              background: filter === v ? '#1a6080' : '#0d1820',
              color: filter === v ? '#fff' : '#7ab0cc' }}>
            {l}
          </button>
        ))}
      </div>

      {loading ? (
        <div style={{ color: '#4a6878', padding: 20 }}>⏳ 載入中...</div>
      ) : filtered.length === 0 ? (
        <div style={{ color: '#4a6878', padding: 20, textAlign: 'center' }}>目前沒有留言</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {filtered.map(m => (
            <div key={m.id} style={{
              background: m.is_read ? '#080c14' : '#0a1220',
              border: `1px solid ${m.is_read ? '#1a2a3a' : '#2a5070'}`,
              borderRadius: 8, padding: '14px 16px'
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  {!m.is_read && <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#4C9BB8', display: 'inline-block' }} />}
                  <span style={{ color: '#90c0dc', fontWeight: 600, fontSize: 14 }}>
                    {m.name || '匿名'}
                  </span>
                  {m.contact && <span style={{ color: '#5a8090', fontSize: 12 }}>{m.contact}</span>}
                </div>
                <span style={{ color: '#3a5060', fontSize: 11 }}>{fmtDate(m.created_at)}</span>
              </div>
              <div style={{ color: '#c0d8e8', fontSize: 14, lineHeight: 1.8, marginBottom: 10, whiteSpace: 'pre-wrap' }}>
                {m.content}
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                {!m.is_read && (
                  <button onClick={() => markRead(m.id)}
                    style={{ padding: '4px 12px', borderRadius: 5, border: '1px solid #2a5070', background: 'transparent', color: '#4C9BB8', cursor: 'pointer', fontSize: 12 }}>
                    標記已讀
                  </button>
                )}
                <button onClick={() => del(m.id)}
                  style={{ padding: '4px 12px', borderRadius: 5, border: '1px solid #5a2020', background: 'transparent', color: '#e05c5c', cursor: 'pointer', fontSize: 12 }}>
                  刪除
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
